import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ChatbotTable from '../../components/comman/ChatBotTable';
import Card from "../../components/comman/CountCards";
import CommonModal from "../../components/comman/modal/Modal";
import CountryForm from "../../components/chatbots/CountryForm";
import cards from './JSON/cards.json';
import { useNavigate } from "react-router-dom";
import {
    fetchCountries,
    addCountry,
    updateCountry,
    deleteCountry
} from "../../redux/actions/chatbotActions/countryActions";
import CountryViewData from "../../components/chatbots/CountryViewData";
import CountryView from "../../components/chatbots/CountryView";
import { fetchCategories } from "../../redux/actions/chatbotActions/categoryActions";
import { fetchCards } from "../../redux/actions/chatbotActions/cardActions";
import { fetchChatbotOfferings } from "../../redux/actions/chatbotActions/offering.actions";
import CardSection from "./CardSection";

const CountrySection = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { countries } = useSelector(state => ({
        countries: state.countryReducer?.countries?.data || [],
    }), shallowEqual);

    const [activeCardId, setActiveCardId] = useState("country");
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState("add"); // 'add' | 'edit'
    const [selectedCountry, setSelectedCountry] = useState(null);

    // Delete confirmation modal state
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [countryToDelete, setCountryToDelete] = useState(null);


    
    const columns = [
        { key: "id", label: "ID" },
        { key: "name", label: "Country Name" },
        { key: "status", label: "Status" }
    ];



    const handleAdd = () => {
        setSelectedCountry(null);
        setModalType("add");
        setModalOpen(true);
    };

    const handleEdit = (country) => {
        setSelectedCountry(country);
        setModalType("edit");
        setModalOpen(true);
    };

    // Open delete confirmation modal
    const handleDeleteClick = (country) => {
        setCountryToDelete(country);
        setDeleteModalOpen(true);
    };

    // Confirm delete action
    const confirmDelete = () => {
        dispatch(deleteCountry(countryToDelete.id));
        setDeleteModalOpen(false);
        setCountryToDelete(null);
    };

    const handleFormSubmit = (formData) => {
        const payload = formData?.countries;
        if (modalType === "edit") {
            dispatch(updateCountry(selectedCountry.id, payload[0]));
        } else {
            dispatch(addCountry(payload));
        }
        setModalOpen(false);
    };

    const handleStatusClick = (country) => {
        dispatch(updateCountry(country.id, { status: country.status === 1 ? 0 : 1 }));
    };

    const handleView = (country) => {
        setSelectedCountry(country);
        setModalType("view");
        setModalOpen(true);
    };

    return (
        <div className="content-chatbot">
            <h1 className="text-3xl font-bold mb-8 text-gray-800">Country Management</h1>

            {/* Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-6">
                <CardSection />
            </div>

            {/* Table */}
            {activeCardId === "country" && (
                <ChatbotTable
                    title="Country"
                    columns={columns}
                    data={countries}
                    btnName="Add New Country"
                    onAdd={handleAdd}
                    onView={handleView}
                    onEdit={handleEdit}
                    onDelete={handleDeleteClick}
                    handleStatusClick={handleStatusClick}
                />
            )}

            {/* Add/Edit Modal */}
            {/* Add/Edit/View Modal */}
            {modalOpen && (
                <CommonModal
                    isOpen={modalOpen}
                    onClose={() => setModalOpen(false)}
                    title={
                        modalType === "add"
                            ? "Add New Country"
                            : modalType === "edit"
                                ? "Edit Country"
                                : "Country Details"
                    }
                >
                    {modalType === "view" ? (
                        <CountryView country={selectedCountry} />
                    ) : (
                        <CountryForm
                            onSubmit={handleFormSubmit}
                            updateData={selectedCountry}
                            hidebtn={modalType === "edit"} // optional, like your Card example
                            btnName={modalType === "add" ? "Add Country" : "Update Country"}
                        />
                    )}
                </CommonModal>
            )}


            {/* Delete Confirmation Modal */}
            {deleteModalOpen && countryToDelete && (
                <CountryViewData
                    deleteModalOpen={deleteModalOpen}
                    setDeleteModalOpen={setDeleteModalOpen}
                    countryToDelete={countryToDelete}
                    confirmDelete={confirmDelete}
                />
            )}
        </div>
    );
};

export default CountrySection;
